import React from 'react';

import './fitment-tire-size-oe-dropdown-option-tire-size.scss';

interface FitmentTireSizeOeDropdownOptionTireSizeProps {
  description: string;
  diameter: string | undefined;
  label: string;
}

function FitmentTireSizeOeDropdownOptionTireSize(
  props: FitmentTireSizeOeDropdownOptionTireSizeProps
) {
  const { description, diameter, label } = props;
  return (
    <span styleName="container">
      <strong
        className="fitment-tire-size-oe-dropdown-option__oe-highlight"
        styleName="highlight"
      >
        {description}
      </strong>{' '}
      <strong>{label}</strong> | <strong>{`${diameter ?? ''}”`}</strong> wheels
    </span>
  );
}

export default FitmentTireSizeOeDropdownOptionTireSize;
